const getIsPayoutEnabled = () => {
    const isPayoutEnabled = localStorage.getItem("isPayoutEnabled")
        ? JSON.parse(localStorage.getItem("isPayoutEnabled"))
        : null;

    return isPayoutEnabled;
};

const InitialState = {
    isPayoutEnabled: getIsPayoutEnabled(),
};

const IsPayoutEnabledReducer = (state = InitialState, action) => {
    if (action.type === "Save_isPayoutEnabled") {
        const newState = {
            ...state,
            isPayoutEnabled: action.payload,
        };
        localStorage.setItem("isPayoutEnabled", JSON.stringify(action.payload));
        return newState;
    }

    else if (action.type === "Remove_User") {
        localStorage.removeItem("isPayoutEnabled");
        const newState = {
            isPayoutEnabled: null
        };
        return newState;
    }

    return state;
};

export default IsPayoutEnabledReducer;